import { number, string, type } from "superstruct";

export const WishlistItemSchema = type({
    wishlistId: number(),
    customerId: number(),
    productId: number(),
    variantId: number(),
    date: string(),
});
